import React, { useState, useEffect } from 'react';
import HamburgerMenu from './Navbar/HamburgerMenu';
import DesktopNav from './Navbar/DesktopNav';
import MobileNav from './Navbar/MobileNav';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const [bgOpacity, setBgOpacity] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      let ratio = scrollY / windowHeight;
      if (ratio > 1) ratio = 1;

      setBgOpacity(ratio * 0.3);
      setIsScrolled(scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(prevState => !prevState);
  };

  return (
    <>
      <nav
        className={`top-0 left-0 w-full z-20 transition-all duration-1000 px-8 md:px-0 xl:px-24 flex items-center justify-between ${isHomePage ? 'text-white fixed' : 'text-gray-600'
          } ${isScrolled ? 'py-4' : 'py-8'}`}
        style={{
          backgroundColor: isHomePage
            ? `rgba(17, 24, 39, ${bgOpacity})`
            : 'rgb(255 255 255)', // White background for non-homepages
          backdropFilter: isHomePage && bgOpacity > 0 ? 'blur(10px)' : '',
        }}
      >
        {/* Gradient background layer */}
        {isHomePage && (
          <div
            className="absolute -top-1 left-0 w-full h-full z-[-1] pointer-events-none"
            style={{
              background: 'linear-gradient(to bottom, #212121, #ffffff00)',
              opacity: bgOpacity === 0 ? 1 : 0,
              transition: 'opacity 0.5s ease',
            }}
          />
        )}

          {/* Logo */}
          <div className={`md:pl-10 xl:pl-8 font-bold duration-300 ${isScrolled ? 'text-lg' : 'text-2xl'
            }`}
          >
            <Link to="/"><h1 className='inline text-3xl'>Slade<h1 className='inline text-5xl'>J</h1>ustin.</h1></Link>
          </div>

          {/* Hamburger Icon */}
          <div className="z-50 relative">
            <HamburgerMenu isMobileMenuOpen={isMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />
          </div>

          {/* Desktop Navigation */}
          <DesktopNav isHomePage={isHomePage} className="hidden sm:block" />
          
      </nav>

      {/* Mobile Navigation */}
      <MobileNav
        isMobileMenuOpen={isMobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
        isScrolled={isScrolled}
      />
    </>
  );
}

export default Navbar;